export default __webpack_public_path__ + "assets/images/d9774cd214c422562dab8473319cada4.svg";